// extracted by mini-css-extract-plugin
export default {"section":"section_section__mmqoC","label":"section_label__rzEk2"};